import React from 'react';
import { BsCheck2Circle } from 'react-icons/bs';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';

const ResetPasswordSuccess = ({ onContinue }) => (
  <div className="flex flex-col gap-4 justify-center items-center w-full text-center">
    <div className="flex justify-center items-center p-3 mb-3 bg-green-100 rounded-full">
      <BsCheck2Circle className="text-green-600" size={28} />
    </div>
    <div className="text-xl font-semibold">Password Reset Successfully!</div>
    <div className="text-gray-700">Your password has been updated successfully. You can now use your new password to sign in.</div>
    <CustomButtonNew label="Continue" onClick={onContinue} />
  </div>
);

export default ResetPasswordSuccess; 